import dynamic from 'next/dynamic';

import { NextLink } from '@/atoms';
import { Button } from '@/molecules';

import styles from './Error.module.css';

import type { FunctionComponent } from 'react';
import type { TypeErrorProps } from './types';

const Oops = dynamic(() => import('@/assets/images/Oops.svg'), { ssr: false });

/**
 * Error
 */
export const Error: FunctionComponent<TypeErrorProps> = ({
  className = '',
  title,
  children,
  link,
}: TypeErrorProps) => (
  <div className={`${styles['c-error']} ${className}`}>
    <div className={styles['c-error__left']}>
      <div className={styles['c-error__copy']}>
        {title && <h1 className={styles['c-error__title']}>{title}</h1>}

        {children && <p className={styles['c-error__text']}>{children}</p>}

        {link && (
          <NextLink href={link.href} passHref>
            <Button
              as="a"
              label={link.label}
              className={styles['c-error__button']}
              size="normal"
              {...(link.onClick && { onClick: link.onClick })}
            />
          </NextLink>
        )}
      </div>
    </div>

    <div className={styles['c-error__right']}>
      <Oops
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        className={styles['c-error__image']}
      />
    </div>
  </div>
);

Error.displayName = 'Error';
